import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../services/http.service';
import { OrgBusinessUnit } from './org-business-unit.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class OrgBusinessUnitsApiService {
  constructor(private http: HttpService) {}

  public getOrgBusinessUnitsForUser(userProfileUId: string): Observable<OrgBusinessUnit[]> {
    const url = `${apiBaseUrl}/v1/data/orgbusinessunits/user-units/${userProfileUId}`;

    return this.http.get(url);
  }

  public getOrgBusinessUnitsForSelectionForUser(userProfileUId: string, selectedIds: string[]): Observable<OrgBusinessUnit[]> {
    const url = `${apiBaseUrl}/v1/data/orgbusinessunits/user-units-selection/${userProfileUId}`;

    const selectionRequest = {
      uIds: selectedIds ?? []
    };
    return this.http.post(url, selectionRequest);
  }

  public getOrgBusinessUnitsByUIds(selectedIds: string[]): Observable<OrgBusinessUnit[]> {
    const url = `${apiBaseUrl}/v1/data/orgbusinessunits/units-by-uids`;

    const selectionRequest = {
      uIds: selectedIds ?? []
    };
    return this.http.post(url, selectionRequest);
  }

  public getAllOrgBusinessUnits(): Observable<OrgBusinessUnit[]> {
    const url = `${apiBaseUrl}/v1/data/orgbusinessunits/all-user-units`;

    return this.http.get(url);
  }

  public hasOrgBusinessUnits(): Observable<boolean> {
    const url = `${apiBaseUrl}/v1/data/orgbusinessunits/has-units`;

    return this.http.get(url);
  }

  public getOrgBusinessUnitsByUId(uid: string): Observable<OrgBusinessUnit[]> {
    const url = `${apiBaseUrl}/v1/data/orgbusinessunits/units-by-uid/${uid}`;

    return this.http.get(url);
  }

  // returns a list of unit updated plus any descendant units that get updated from level changes
  public updateOrgBusinessUnit(businessUnit: OrgBusinessUnit): Observable<OrgBusinessUnit[]> {
    const url = `${apiBaseUrl}/v1/data/orgbusinessunits/${businessUnit.uId}`;

    return this.http.put(url, businessUnit);
  }

  public createOrgBusinessUnit(businessUnit: Partial<OrgBusinessUnit>): Observable<OrgBusinessUnit> {
    const url = `${apiBaseUrl}/v1/data/orgbusinessunits`;

    return this.http.post(url, businessUnit);
  }

  public deleteOrgBusinessUnit(businessUnit: OrgBusinessUnit): Observable<void> {
    const url = `${apiBaseUrl}/v1/data/orgbusinessunits/${businessUnit.uId}`;

    return this.http.delete(url);
  }
  
}
